import { keyCodes } from '@constants/keyboard/keyboard-constans';
import React, { useState } from 'react';
import cn from 'classnames';
import { useLayoutBreakpoint } from '../../../hooks/use-layout-breakpoint';
import { Card } from '../card/card';

const MappedCards = ({ subsection, data, setShowArrows }) => {
  const [hover, setHover] = useState(null);

  const isHovered = (id) => hover === subsection + id;
  const setHoverIndex = (id) => subsection + id;

  const breakpoint = useLayoutBreakpoint();

  /**
   * Handles the keydown event on the element governing the opening/closing of submenu.
   * @param {*} event
   */
  const handleKeyDown = React.useCallback(
    () => (event) => {
      switch (event.keyCode) {
        case keyCodes.ENTER: {
          setShowArrows(true);
          break;
        }
        default:
          break;
      }
    },
    [keyCodes, setShowArrows]
  );

  const mappedCards = React.useMemo(
    () =>
      data?.map((article) => (
        <div
          key={article._id}
          className="d-flex flex-row justify-content-center py-3 pl-1 pr-3"
          onMouseOut={() => setHover(null)}
          onBlur={() => setHover(null)}
          onMouseOver={() => setHover(setHoverIndex(article._id))}
          onFocus={() => setHover(setHoverIndex(article._id))}
        >
          <Card isHovered={isHovered(article._id)} article={article} />
        </div>
      )),
    [data, setHover, isHovered, setHoverIndex]
  );

  const mappedCardsMobile = React.useMemo(
    () =>
      data?.map((article, index) => (
        <div
          key={article._id}
          onMouseOut={() => {
            setHover(null);
            setShowArrows(true);
          }}
          onBlur={() => {
            setHover(null);
            setShowArrows(true);
          }}
          onMouseOver={() => setHover(setHoverIndex(article._id))}
          onFocus={() => {
            setHover(setHoverIndex(article._id));
            setShowArrows(false);
          }}
          onClick={() => setShowArrows(false)}
          tabIndex="0"
          role="button"
          onKeyDown={handleKeyDown}
          className={cn(`d-flex w-100 flex-row justify-content-center`, {
            'mb-4': index !== data?.length - 1,
            'mt-5': index !== 0
          })}
        >
          <Card isHovered={isHovered(article._id)} article={article} />
        </div>
      )),
    [data, setHover, setShowArrows, handleKeyDown, isHovered, setHoverIndex]
  );

  return (
    <div
      className="snf-lx-components-storie-successo-mapped-cards-mapped-cards"
      style={{ display: 'contents' }}
    >
      <>
        {breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md' ? (
          <div className="d-flex w-100 cards">{mappedCardsMobile}</div>
        ) : (
          <div className="row justify-content-md-around w-100 m-0 cards">{mappedCards}</div>
        )}
      </>
    </div>
  );
};

export { MappedCards };
